import { BehaviorSubject } from 'rxjs';
export const getHistoricalModuleFormStore = () => {
    const getInitialState = () => ({
        historicalModuleTemplate: {
            companyName: null,
            fiscalLoss: {
                items: []
            },
            excessCost: {
                items: [],
                requiredYears: null
            },
            sponsorshipExpenses: {
                items: []
            }
        },
        isLoading: true
    });
    const subject = new BehaviorSubject(getInitialState());
    const subscribe = (callback) => subject.subscribe(callback);
    const setHistoricalModuleTemplate = (template) => subject.next({
        historicalModuleTemplate: template,
        isLoading: false
    });
    const getHistoricalModuleTemplate = () => subject.getValue().historicalModuleTemplate;
    const reset = () => subject.next(getInitialState());
    return {
        getInitialState,
        setHistoricalModuleTemplate,
        getHistoricalModuleTemplate,
        reset,
        subscribe
    };
};
